<div class="h-100 t2 c-primary-gray-900" fxLayout="column" fxLayoutAlign="start start">
    <mat-expansion-panel class="w-100">
        <mat-expansion-panel-header class="w-100"
                                    fxLayout="start start">
            <mat-panel-title class="no-wrap t2-semi-bold"> {{ 'i18n_af_labelTrendDescription' | translate }}</mat-panel-title>
        </mat-expansion-panel-header>
        <div class="mt-8">
            <div>{{ trend.description }}</div>
        </div>
    </mat-expansion-panel>

    <mat-expansion-panel class="w-100 mt-12">
        <mat-expansion-panel-header class="w-100"
                                    fxLayout="start start">
            <mat-panel-title class="no-wrap t2-semi-bold"> {{ 'i18n_af_labelTrendKeywords' | translate }}</mat-panel-title>
        </mat-expansion-panel-header>
        <div class="mt-8">
            <div>{{ trend.keywords }}</div>
        </div>
    </mat-expansion-panel>

    <mat-expansion-panel class="w-100 mt-12">
        <mat-expansion-panel-header class="w-100"
                                    fxLayout="start start">
            <mat-panel-title class="no-wrap t2-semi-bold"> {{ 'i18n_af_labelTrendConclusion' | translate }}</mat-panel-title>
        </mat-expansion-panel-header>
        <div class="mt-8">
            <div>{{ trend.conclusion }}</div>
        </div>
    </mat-expansion-panel>

</div>
